import LoginForm from "../../components/personal/AuthPage/LoginForm";

export default function AuthPage(){
    return(
        <>
        <div>
            <LoginForm/>
        </div>
        </>
    )
}